import * as icons from 'core/icons';

const maestros = {
    id: 'maestros',
    title: 'Maestros',
    type: 'group',
    collapse: false,
    visible: true,
    children: [
        {
            id: 'clientes',
            title: 'Clientes',
            type: 'item',
            visible: true,
            url: '/gestion/maestros/clientes',
            icon: icons.ClientesIcon,
            breadcrumbs: false
        },
        {
            id: 'proveedores',
            title: 'Proveedores',
            type: 'item',
            visible: true,
            url: '/gestion/maestros/proveedores',
            icon: icons.ProveedoresIcon,
            breadcrumbs: false
        },
        {
            id: 'productos',
            title: 'Productos',
            type: 'item',
            url: '/gestion/maestros/productos',
            icon: icons.ProductosIcon,
            breadcrumbs: false
        },
        {
            id: 'usuarios',
            title: 'Usuarios',
            type: 'item',
            visible: true,
            url: '/gestion/maestros/usuarios',
            icon: icons.UsuariosIcon,
            breadcrumbs: false
        }
    ]
};

export default maestros;
